<form [formGroup]="form" novalidate >
  <div class="form-section-body">
    <div class="form-block block-plan-rules">
      <div class="block-content">
        <div class="form-row row-checkbox border noborder-important">
          <mat-checkbox #enablePrepaidSubscription [disabled]="_selectedChargeType === _chargeType.oneTimeCharge" (change)="onChangePrepaidRuleSubscription($event)" formControlName="prepaidRulesEnabled" disableRipple="true"  color="primary" class="custom-mat-checkbox checkbox-simple-line rounded">
          <span class="typo semi-condensed fw400">Yes, I would like to set a prepaid rule to this charge</span>
        </mat-checkbox>
        </div>
      </div>
      <div [@onRowStatusChange]="(enablePrepaidSubscription.checked ? _visibleState.isVisible : _visibleState.isHidden)" class="block-content">
        <div class="form-row">
          <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field custom-mat-form-field-outline size size1of1">
            <mat-label>Action</mat-label>
            <mat-select disableOptionCentering="true" class="custom-mat-select" formControlName="prepaidAction">
              <mat-option *ngFor="let action of collectionOfPrepaidRulesAction" [value]="action.value" class="custom-mat-option">{{action.label | titlecase}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field custom-mat-form-field-outline size size1of2">
            <mat-label>Type</mat-label>
            <mat-select disableOptionCentering="true" class="custom-mat-select" formControlName="prepaidRulesAmountType">
              <mat-option *ngFor="let action of collectionOfPrepaidRulesAmountTypes" [value]="action.value" class="custom-mat-option">{{action.label | titlecase}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field custom-mat-form-field-outline size size1of2">
            <mat-label>Amount</mat-label>
            <input matInput type="text"formControlName="prepaidRulesAmount" [cleave]="cleaveNumDecimalOptions">
            <mat-error><error-messages [control]="form.get('prepaidRulesAmount')"></error-messages></mat-error>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field custom-mat-form-field-outline size size1of2">
            <mat-label>Count Type</mat-label>
            <mat-select  disableOptionCentering="true" formControlName="prepaidCountType" class="custom-mat-select">
              <mat-option value="every" class="custom-mat-option">Every</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" class="custom-mat-form-field custom-mat-form-field-outline size size1of2">
            <mat-label>Count</mat-label>
            <input matInput type="text" formControlName="prepaidCount" maxlength="3" [cleave]="cleaveNumIntegerOptions">
            <mat-error><error-messages [control]="form.get('PrepaidCount')"></error-messages></mat-error>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="custom-mat-form-field custom-mat-form-field-outline size size1of1">
            <mat-label>Event</mat-label>
            <mat-select required  disableOptionCentering="true" class="custom-mat-select" formControlName="prepaidEvent">
              <mat-option *ngFor="let type of collectionOfPrepaidRulesEvents" [value]="type.value" class="custom-mat-option">{{type.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
